import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  CapTableTab,
  Column,
  ShareClassColumns,
  StakeholderColumns,
  StakeholdersViewBy,
} from '../liquidity.types';
import { FirstTableRowPayload, SecondTableRowPayload, TableRow } from './table-row';

export type TotalRowProps = {
  fields:
    | Record<ShareClassColumns, FirstTableRowPayload | null>
    | Record<StakeholderColumns, FirstTableRowPayload | null | SecondTableRowPayload>;
  selectedViewBy?: 'all' | StakeholdersViewBy;
  tab: CapTableTab;
  trClassName?: false | string;
  viewBy?: Record<StakeholdersViewBy, boolean>;
  visibleColumns: Column[];
};

export const TotalRow: FC<TotalRowProps> = ({
  fields,
  visibleColumns,
  tab,
  viewBy,
  selectedViewBy,
  trClassName = '',
}) => {
  const commonProps = {
    isExpandedRow: true,
    tdClassName: 'font-[550] text-gray-800',
    trClassName: 'border-t-[1px] border-gray-200',
    visibleColumns,
    viewBy,
    selectedViewBy,
  };

  return (
    <>
      {tab === CapTableTab.BY_SHARE_CLASS ? (
        <TableRow
          {...commonProps}
          fields={
            fields as Record<
              ShareClassColumns,
              {
                change: null;
                value: string;
              }
            >
          }
          tab={CapTableTab.BY_SHARE_CLASS}
          trClassName={twMerge(trClassName, commonProps.trClassName)}
        />
      ) : (
        <TableRow
          {...commonProps}
          fields={
            fields as Record<
              StakeholderColumns,
              {
                change: null;
                value: string;
              }
            >
          }
          tab={CapTableTab.BY_STAKEHOLDER}
          trClassName={twMerge(trClassName, commonProps.trClassName)}
        />
      )}
    </>
  );
};
